import {brand, Branded, number, TypeOf} from 'io-ts';

interface PositiveBrand {
    readonly Positive: unique symbol;
}

export const Positive = brand(number, (n): n is Branded<number, PositiveBrand> => n > 0, 'Positive');

export type Positive = TypeOf<typeof Positive>;
